var React = require('react');

function ButtonArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.235 0L13 5.021 8.235 10M13 5H0","className":"icon-stroke"}));
}

ButtonArrow.defaultProps = {"className":"button__icon","width":"14","height":"10","fill":"none"};

module.exports = ButtonArrow;

ButtonArrow.default = ButtonArrow;
